module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "home-body"
  }, [_vm._c('div', {
    staticClass: "wrap-blue banner-with-copy"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-md-push-6 col-md-6 pic"
  }, [_vm._c('picture', {
    attrs: {
      "title": ""
    }
  }, [_vm._c('source', {
    attrs: {
      "srcset": "/static/img/advertise/banner2_400.jpg",
      "media": "(min-width: 501px) and (max-width: 800px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/advertise/banner2_600.jpg",
      "media": "(min-width: 801px) and (max-width: 1200px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/advertise/banner2_800.jpg",
      "media": "(min-width: 1201px) and (max-width: 1600px)"
    }
  }), _vm._v(" "), _vm._c('source', {
    attrs: {
      "srcset": "/static/img/advertise/banner2_1000.jpg",
      "media": "(min-width: 1601px)"
    }
  }), _vm._v(" "), _vm._c('img', {
    attrs: {
      "src": "/static/img/advertise/banner2_800.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "overlay"
  })], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-md-pull-6 col-md-6 banner-content-wrap"
  }, [_vm._c('div', {
    staticClass: "banner-copy"
  }, [_vm._m(0), _vm._v(" "), _vm._c('p', [_vm._v("\n            Part of our mission is bringing people together who love to learn! Come be a part of it and see what CLEX advertising has to offer. We can serve your brand’s ads either directly on our secure platform or from your preferred third-party provider (Google, Bing, etc.).\n          ")]), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn-pub btn-pub-blank xs-full-width",
    attrs: {
      "to": {
        name: 'contact-us'
      }
    }
  }, [_vm._v("Become A Partner Today")])], 1)])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "ptb-100 text-center ad-content"
  }, [_vm._c('div', {
    staticClass: "inner"
  }, [_vm._c('p'), _vm._c('h2', {
    staticClass: "xs-mb-50"
  }, [_vm._v("As Seen On...")]), _vm._v(" "), _vm._c('p'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._c('p', {
    staticClass: "xs-mb-50 large-text"
  }, [_vm._v("We can achieve much more when we learn together. Become part of our team as an Advertising Partner.")]), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn-pub btn-pub-border-primary",
    attrs: {
      "to": {
        name: 'contact-us'
      }
    }
  }, [_vm._v("Become A Partner Today")]), _vm._v(" "), _vm._c('div', {
    staticClass: "row xs-pt-50"
  }, [_vm._c('div', {
    staticClass: "col-xs-12"
  }, [_vm._c('HorizontalAd', {
    attrs: {
      "containerClass": ''
    }
  })], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('h1', [_vm._v("Become "), _vm._c('br'), _vm._v("A Partner")])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "row xs-mb-50"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-3 xs-p-10"
  }, [_vm._c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/img/advertise/google.png",
      "alt": "Google",
      "title": "Google"
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-3 xs-p-10"
  }, [_vm._c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/img/advertise/bing.gif",
      "alt": "Bing",
      "title": "Bing"
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-3 xs-p-10"
  }, [_vm._c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/img/advertise/Taboola.png",
      "alt": "Taboola",
      "title": "Taboola"
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-3 xs-p-10"
  }, [_vm._c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/img/advertise/Yahoo.png",
      "alt": "Yahoo",
      "title": "Yahoo"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2596bf9f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/AdvertisePage.vue
// module id = 637
// module chunks = 1